// *******************************************************************************
// Marquee Text with ScrollMagic
// *******************************************************************************

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const marqueeText = document.querySelectorAll('.marquee-text');

  if (marqueeText.length > 0) {
    const controller = new ScrollMagic.Controller();
    const marqueeMm = gsap.matchMedia();
    marqueeText.forEach((marquee) => {
      const track = marquee.querySelector('.marquee-text__inner');

      marqueeMm.add('(min-width: 1023px)', () => {
        const marqueeTween = gsap.to(track, {
          x: '-100%',
          ease: 'none',
        });

        new ScrollMagic.Scene({
          triggerElement: parent,
          triggerHook: 1,
          duration: '200%',
        })
          .setTween(marqueeTween)
          .addTo(controller);
      });

      marqueeMm.add('(max-width: 1022px)', () => {
        const marqueeTween = gsap.to(track, {
          x: '-200%',
          ease: 'none',
        });

        new ScrollMagic.Scene({
          triggerElement: parent,
          triggerHook: 1,
          duration: '200%',
        })
          .setTween(marqueeTween)
          .addTo(controller);
      });
    });
  }
});
